import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import { AssetSectionFields } from '../BorrowAssets';
import MessageBar from './MessageBar';
import HealthState from './HealthState';
import LeverageFactor from './LeverageFactor';
import { useRiskFactorStyle } from './RiskFactor.style';

import { Agreement } from '@/shared/api/borrow';

type RiskFactorProps = {
    health: string | null;
    agreement: Agreement;
    collateralMarketValue: string | null;
};

export enum RiskFactorFields {
    MULTIPLIER = 'multiplier',
    STRATEGY = 'strategy',
}

const RiskFactor = ({ health, collateralMarketValue, agreement }: RiskFactorProps) => {
    const classes = useRiskFactorStyle();

    const { watch, control } = useFormContext();

    const selectedAssets = watch(AssetSectionFields.SELECTED_ASSETS);

    const { decimals } = {
        decimals: agreement.leverage.decimals,
    };

    return (
        <>
            <HealthState health={health} agreement={agreement} />
            {selectedAssets?.length ? (
                <>
                    <div className={classes.separator} />
                    <Controller
                        name={RiskFactorFields.MULTIPLIER}
                        defaultValue={1}
                        control={control}
                        render={({ field }) => (
                            <LeverageFactor
                                {...field}
                                collateralMarketValue={collateralMarketValue}
                                selectedAssets={selectedAssets}
                                decimals={decimals}
                            />
                        )}
                    />
                </>
            ) : null}
            <MessageBar health={health} agreement={agreement} />
        </>
    );
};

export default RiskFactor;
